<template lang="html">
  <div :id="sectionId" class="list-product">
    <div class="list-product-title mb-2 ml-3">
      {{ title }}
    </div>
    <div>
      <div ref="verticalScroll" class="wrap-list-scroll" @mousedown="onMouseDown" @mouseup="onMouseUp">
        <div class="content-list-scroll">
          <template v-for="(item, i) in items">
            <div v-if="item.item" :key="i" :class="[`product-scroll`, { 'disable': disabled(item.item) || checkStock(item.item) || !item.__cart_data.is_available }]" @click="goDetail(item)">
              <div class="item-avatar-product">
                <!-- <img v-if="!$isEmpty(defaultVariant(item))" :src="defaultVariant(item, 'photo_md')" :alt="item.name + ' (' + defaultVariant(item, 'name') + ')'"> -->
                <img :src="item.item.photo_md" :alt="item.item.name" class="rounded-br-0 rounded-bl-0" @error="imageLoadError">
              </div>
              <div class="item-content-product-scroll">
                <div :class="[`item-title-product font-12 line-height-normal`, { 'font-weight-700 ol-brand': item.__cart_data.qty > 0 }]">
                  {{ item.__cart_data.qty > 0 ? item.__cart_data.qty + 'x' : '' }} {{ item.item.name }}
                </div>
                <div v-if="checkStock(item.item) || !item.__cart_data.is_available" class="item-price-product is-out-stock">
                  {{ $t('v2.out_of_stock') }}
                </div>
                <template v-else>
                  <div v-if="Number(item.item.pos_sell_price_dynamic) === 1 && Number($store.state.selected_outlet.setting.pos_dynamic_price_can_order) === 0" class="item-price-product order-at-cashier">
                    {{ $t('v2.order_at_cashier') }}
                  </div>
                  <div v-else class="item-price-product d-flex align-center">
                    <span v-if="$usePosPrice()" v-mask-money="item.item.sell_price_pos" />
                    <span v-else v-mask-money="item.item.sell_price" />
                  </div>
                  <div v-if="Number(item.item.market_price) !== 0" class="d-flex align-center">
                    <span v-mask-money="item.item.market_price" class="fav-market-price" />
                    <div class="ml-1">
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 1C5.6325 1 5.76 1.0525 5.8535 1.1465L10.8535 6.1465C11.049 6.342 11.049 6.658 10.8535 6.8535L6.8535 10.8535C6.756 10.951 6.628 11 6.5 11C6.372 11 6.244 10.951 6.1465 10.8535L1.1465 5.8535C1.0525 5.76 1 5.633 1 5.5V3C1 2.867 1.0525 2.74 1.1465 2.6465L2.6465 1.1465C2.74 1.0525 2.8675 1 3 1H5.5ZM2 5.293L6.5 9.793L9.793 6.5L5.293 2H3.207L2 3.207V5.293ZM5.00003 4.1765C5.00003 4.6313 4.63133 5 4.17653 5C3.72172 5 3.35303 4.6313 3.35303 4.1765C3.35303 3.72169 3.72172 3.353 4.17653 3.353C4.63133 3.353 5.00003 3.72169 5.00003 4.1765Z" fill="#F44336" />
                      </svg>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      required: true,
      type: String
    },
    items: {
      required: true,
      type: Array
    },
    sectionId: {
      required: true,
      type: String
    },
    clickDetail: {
      required: true,
      type: Function
    }
  },
  data() {
    return {
      cursorPos: [0, 0],
      verticalScroll: null
    }
  },
  mounted() {
    window.addEventListener('mouseup', this.onMouseUp)
  },
  destroyed() {
    window.removeEventListener('mouseup', this.onMouseUp)
  },
  methods: {
    imageLoadError(event) {
      event.target.src = require('@/assets/images/product_not_available.png')
    },
    disabled() {
      if (!this.$isEmpty(this.$store.state.selected_outlet)) {
        const openStore = this.$store.state.selected_outlet.store_is_open === 1
        if (!openStore) {
          return true
        } else {
          if (this.$store.state.selected_type === 'DINE-IN' && this.$store.state.selected_outlet.setting.use_dinein === 1) {
            return false
          } else if (this.$store.state.selected_type === 'OL-TAKE-AWAY' && this.$store.state.selected_outlet.setting.use_takeaway === 1) {
            return false
          } else if (this.$store.state.selected_type === 'DELIVERY' && this.$store.state.selected_outlet.setting.use_delivery === 1) {
            return false
          } else if (this.$store.state.selected_type === 'RESERVATION' && this.$store.state.selected_outlet.setting.use_reservation === 1) {
            return false
          } else {
            return true
          }
        }
      } else {
        return true
      }
    },
    async goDetail(item) {
      if (!this.disabled(item)) {
        await this.clickDetail(item)
      }
    },
    checkStock(item) {
      if (typeof item.items !== 'undefined') {
        if (item.is_out_stock) {
          return true
        }
      } else {
        if (item && item.has_variant && Array.isArray(item.variants)) {
          let isDisabled = true
          for (let i = 0; i < item.variants.length; i++) {
            const variant = item.variants[i]
            if (item.track_inventory) {
              if (!variant.is_out_stock && Number(variant.hold_qty) + this.$stockCart(variant.id, '_v2_cart', 'variant') < Number(variant.stock_qty)) {
                isDisabled = false
                break
              }
            } else {
              if (!variant.is_out_stock) {
                isDisabled = false
                break
              }
            }
          }
          return isDisabled
        } else {
          if (item.track_inventory) {
            if (item.is_out_stock || this.$stockCart(item.id) + Number(item.hold_qty) >= Number(item.stock_qty)) {
              return true
            }
          } else {
            if (item.is_out_stock) {
              return true
            }
          }
        }
      }
      return false
    },
    // defaultVariant(item, value = '') {
    //   const arrayData = item.variants
    //   const variant = arrayData.findIndex(obj => {
    //     return obj.id === item.default_variant_id
    //   })
    //   if (variant !== -1) {
    //     if (value !== '') {
    //       return item.variants[variant][value]
    //     } else {
    //       return item.variants[variant]
    //     }
    //   } else {
    //     return {}
    //   }
    // },
    onMouseDown(ev) {
      this.cursorPos = [ev.pageX, ev.pageY]
      window.addEventListener('mousemove', this.onMouseHold)
    },
    onMouseUp(ev) {
      window.removeEventListener('mousemove', this.onMouseHold)
    },
    onMouseHold(ev) {
      ev.preventDefault()
      requestAnimationFrame(() => {
        const delta = [
          ev.pageX - this.cursorPos[0],
          ev.pageY - this.cursorPos[1]
        ]
        this.cursorPos = [ev.pageX, ev.pageY]
        if (!this.$refs.verticalScroll) return
        this.$refs.verticalScroll.scrollBy({
          left: -delta[0],
          top: -delta[1]
        })
      })
    },
    async showDetail(item) {
      await this.clickDetail(item)
    }
  }
}
</script>
<style>
.wrap-list-scroll {
  contain: content;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  overflow-x: scroll;
  cursor: auto;
}
.content-list-scroll {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1 0 auto;
  flex: 1 0 auto;
  position: relative;
  white-space: nowrap;
  padding: 4px;
}
.wrap-list-scroll::-webkit-scrollbar-track,
.wrap-list-scroll::-webkit-scrollbar,
.wrap-list-scroll::-webkit-scrollbar-thumb {
  display: none;
}
.product-scroll{
  width: 112px;
  overflow: hidden;
  margin-right: 12px;
  box-shadow: 0px 2px 2px 0px #0000001F;
  border-radius: 8px;
  z-index: 2;
  cursor: pointer;
}
.product-scroll.disable{
  pointer-events: none;
  cursor: not-allowed;
  -webkit-user-select: none;
  -ms-user-select: none;
  -moz-user-select: none;
  user-select: none;
}
.product-scroll.disable > .item-avatar-product{
  opacity: .64;
}
.product-scroll.disable img {
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
}
.product-scroll.disable .item-title-product, .product-scroll.disable .item-price-product {
  color: #767676;
}
.product-scroll.disable .fav-market-price{
  color: #a0a0a0;
}
.product-scroll.disable .item-price-product.is-out-stock, .item-product.disable .item-price-product.is-out-stock {
  color: #F44336;
}
.product-scroll:first-child{
  margin-left: 12px;
}
.product-scroll:last-child{
  margin-right: 0px;
}
.item-content-product-scroll{
  padding: 8px;
}
</style>
